module.exports = __webpack_public_path__ + "static/img/academy_edu_learn_2.e235ce8d.png";